// This file is generated by scripts/assets.mjs
/** @public */
export type TLUiIconType =
	| 'align-bottom'
	| 'align-center-horizontal'
	| 'align-center-vertical'
	| 'align-left'
	| 'align-right'
	| 'align-top'
	| 'arrow-left'
	| 'arrowhead-arrow'
	| 'arrowhead-bar'
	| 'arrowhead-diamond'
	| 'arrowhead-dot'
	| 'arrowhead-none'
	| 'arrowhead-square'
	| 'arrowhead-triangle-inverted'
	| 'arrowhead-triangle'
	| 'aspect-ratio'
	| 'avatar'
	| 'blob'
	| 'bring-forward'
	| 'bring-to-front'
	| 'check'
	| 'checkbox-checked'
	| 'checkbox-empty'
	| 'chevron-down'
	| 'chevron-left'
	| 'chevron-right'
	| 'chevron-up'
	| 'chevrons-ne'
	| 'chevrons-sw'
	| 'clipboard-copy'
	| 'code'
	| 'codepen'
	| 'codesandbox'
	| 'collab'
	| 'color'
	| 'comment'
	| 'cross-2'
	| 'cross'
	| 'dash-dashed'
	| 'dash-dotted'
	| 'dash-draw'
	| 'dash-solid'
	| 'discord'
	| 'distribute-horizontal'
	| 'distribute-vertical'
	| 'dot'
	| 'dots-horizontal'
	| 'dots-vertical'
	| 'drag-handle-dots'
	| 'duplicate'
	| 'edit'
	| 'excalidraw'
	| 'external-link'
	| 'felt'
	| 'figma'
	| 'file'
	| 'fill-none'
	| 'fill-pattern'
	| 'fill-semi'
	| 'fill-solid'
	| 'font-draw'
	| 'font-mono'
	| 'font-sans'
	| 'font-serif'
	| 'geo-arrow-down'
	| 'geo-arrow-left'
	| 'geo-arrow-right'
	| 'geo-arrow-up'
	| 'geo-diamond'
	| 'geo-ellipse'
	| 'geo-hexagon'
	| 'geo-octagon'
	| 'geo-oval'
	| 'geo-pentagon'
	| 'geo-rectangle'
	| 'geo-rhombus-2'
	| 'geo-rhombus'
	| 'geo-star'
	| 'geo-trapezoid'
	| 'geo-triangle'
	| 'geo-x-box'
	| 'github-embed'
	| 'github'
	| 'group'
	| 'hidden'
	| 'image'
	| 'info-circle'
	| 'link'
	| 'lock-small'
	| 'lock'
	| 'map'
	| 'menu-brand'
	| 'menu'
	| 'minus'
	| 'mixed'
	| 'pack'
	| 'page'
	| 'plus'
	| 'question-mark-circle'
	| 'question-mark'
	| 'redo'
	| 'replit'
	| 'reset-zoom'
	| 'rotate-ccw'
	| 'rotate-cw'
	| 'ruler'
	| 'scratch'
	| 'search'
	| 'send-backward'
	| 'send-to-back'
	| 'settings-horizontal'
	| 'settings-vertical-1'
	| 'settings-vertical'
	| 'share-1'
	| 'share-2'
	| 'size-extra-large'
	| 'size-large'
	| 'size-medium'
	| 'size-small'
	| 'spline-cubic'
	| 'spline-line'
	| 'spotify'
	| 'stack-horizontal'
	| 'stack-vertical'
	| 'stretch-horizontal'
	| 'stretch-vertical'
	| 'text-align-center'
	| 'text-align-justify'
	| 'text-align-left'
	| 'text-align-right'
	| 'tldraw-embed'
	| 'tool-arrow'
	| 'tool-embed'
	| 'tool-eraser'
	| 'tool-frame'
	| 'tool-hand'
	| 'tool-highlighter'
	| 'tool-line'
	| 'tool-media'
	| 'tool-note'
	| 'tool-pencil'
	| 'tool-pointer'
	| 'tool-text'
	| 'trash'
	| 'triangle-down'
	| 'triangle-up'
	| 'twitter'
	| 'undo'
	| 'ungroup'
	| 'unlock-small'
	| 'unlock'
	| 'vimeo'
	| 'visible'
	| 'warning-triangle'
	| 'youtube'
	| 'zoom-in'
	| 'zoom-out'
